//
// ActionTypes
//
import UIDs from "../../../UIDs";

const uid = UIDs.utils.homework;

const ActionTypes = {
    LOAD_HOMEWORK_DATA_ASYNC: `${uid}.loadHomeworkDataAsync`,
    LOAD_HOMEWORK_DATA_SUCCESS: `${uid}.loadHomeworkDataSuccess`,
    LOAD_HOMEWORK_DATA_FAILURE: `${uid}.loadHomeworkDataFailure`,
};

export { ActionTypes };
